import { memo, useState, useEffect, useContext } from 'react';

// material-ui
import { Typography } from '@mui/material';
import { IconChartArcs, IconFile3d, IconMap2, IconForms, IconAppWindow, IconPhoto, IconSettings, IconChartBar, IconFileZip, IconCertificate } from '@tabler/icons';

// project imports
import NavGroup from './NavGroup';
import UserContext from '../../../context/user.jsx';
import api_json from '../../../api/json.js';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
	const { session } = useContext(UserContext);
	const [ama_map_app_eras, set_ama_map_app_eras] = useState([]);
	const [ama_map_web_eras, set_ama_map_web_eras] = useState([]);

	useEffect(() => {
		(async () => {
			if (!session) return;
			try {
				const app_data = await api_json.get({ session, app_uid: 'ama_map_app' });
				set_ama_map_app_eras(app_data.eras || []);
			} catch (e) {
				console.error(e);
			}
			try {
				const web_data = await api_json.get({ session, app_uid: 'ama_map_web' });
				set_ama_map_web_eras(web_data.eras || []);
			} catch (e) {
				console.error(e);
			}
		})();
	}, [session]);

	const build_era_items = (eras, app_uid) => {
		return eras.map((era, index) => ({
			id: `era_${app_uid}_${index}`,
			title: era.name || `Era ${index}`,
			type: 'item',
			url: `/dashboard/${app_uid}/eras/${index}`,
		}));
	};

	const menu_items = [
		{
			id: 'dashboard',
			title: 'Dashboard',
			type: 'group',
			children: [
				{
					id: 'dashboard_page',
					title: 'Dashboard',
					type: 'item',
					url: '/dashboard',
					icon: IconChartArcs,
				},
				{
					id: 'backup',
					title: 'Backup',
					type: 'item',
					url: '/dashboard/backup',
					icon: IconFileZip,
				},
			],
		},
		{
			id: 'ama_map_app',
			title: 'AMA Alberta Map - App',
			type: 'group',
			children: [
				{
					id: 'ama_map_app_eras',
					title: 'Eras',
					type: 'collapse',
					icon: IconMap2,
					children: build_era_items(ama_map_app_eras, 'ama_map_app'),
				},
				{
					id: 'ama_map_app_file_manager',
					title: 'File Manager',
					type: 'item',
					url: '/dashboard/ama_map_app/file_manager',
					icon: IconFile3d,
				},
			],
		},
		{
			id: 'ama_map_web',
			title: 'AMA Alberta Map - Web',
			type: 'group',
			children: [
				{
					id: 'ama_map_web_eras',
					title: 'Eras',
					type: 'collapse',
					icon: IconMap2,
					children: build_era_items(ama_map_web_eras, 'ama_map_web'),
				},
				{
					id: 'ama_map_web_file_manager',
					title: 'File Manager',
					type: 'item',
					url: '/dashboard/ama_map_web/file_manager',
					icon: IconFile3d,
				},
			],
		},
		{
			id: 'ama_tml_app',
			title: 'AMA Timeline - App',
			type: 'group',
			children: [
				{
					id: 'ama_tml_app_sections',
					title: 'Sections',
					type: 'item',
					url: '/dashboard/ama_tml_app/sections',
					icon: IconForms,
				},
				{
					id: 'ama_tml_app_popups',
					title: 'Popups',
					type: 'item',
					url: '/dashboard/ama_tml_app/popups',
					icon: IconAppWindow,
				},
				{
					id: 'ama_tml_app_maps',
					title: 'Maps',
					type: 'item',
					url: '/dashboard/ama_tml_app/maps',
					icon: IconMap2,
				},
				{
					id: 'ama_tml_app_file_manager',
					title: 'File Manager',
					type: 'item',
					url: '/dashboard/ama_tml_app/file_manager',
					icon: IconFile3d,
				},
			],
		},
		{
			id: 'ama_tml_web',
			title: 'AMA Timeline - Web',
			type: 'group',
			children: [
				{
					id: 'ama_tml_web_sections',
					title: 'Sections',
					type: 'item',
					url: '/dashboard/ama_tml_web/sections',
					icon: IconForms,
				},
				{
					id: 'ama_tml_web_popups',
					title: 'Popups',
					type: 'item',
					url: '/dashboard/ama_tml_web/popups',
					icon: IconAppWindow,
				},
				{
					id: 'ama_tml_web_maps',
					title: 'Maps',
					type: 'item',
					url: '/dashboard/ama_tml_web/maps',
					icon: IconMap2,
				},
				{
					id: 'ama_tml_web_file_manager',
					title: 'File Manager',
					type: 'item',
					url: '/dashboard/ama_tml_web/file_manager',
					icon: IconFile3d,
				},
			],
		},
		/*
		{
			id: 'driver_test',
			title: 'AMA Driver Test',
			type: 'group',
			children: [
				{
					id: 'driver_test_submissions',
					title: 'Submissions',
					type: 'item',
					url: '/dashboard/driver_test/submissions',
					icon: IconCertificate,
				},
			],
		},
		*/
		{
			id: 'ama_media',
			title: 'AMA Media-driven',
			type: 'group',
			children: [
				{
					id: 'ama_media_entries',
					title: 'Entries',
					type: 'item',
					url: '/dashboard/ama_media/entries',
					icon: IconPhoto,
				},
				{
					id: 'ama_media_settings',
					title: 'Settings',
					type: 'item',
					url: '/dashboard/ama_media/settings',
					icon: IconSettings,
				},
				{
					id: 'ama_media_stats',
					title: 'Stats',
					type: 'item',
					url: '/dashboard/ama_media/stats',
					icon: IconChartBar,
				},
			],
		}
	];

	const navItems = menu_items.map((item) => {
		switch (item.type) {
			case 'group':
				return <NavGroup key={item.id} item={item} />;
			default:
				return (
					<Typography key={item.id} variant="h6" color="error" align="center">
						Menu Items Error
					</Typography>
				);
		}
	});

	return <>{navItems}</>;
};

export default memo(MenuList);
